module.exports = __webpack_public_path__ + "static/media/ic_image.a4674ca7.svg";